import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { TagText, DeleteTagButton } from '@calendly/tags';
import { Icon } from '@calendly/ui/components/icon';
import classNames from 'classnames';
import { useCallback, useMemo, forwardRef } from 'react';
import { isEnterKey, isSpaceKey } from 'services/keycodes';
import { FullStoryMask } from '../../../../../shared/fullstory_privacy';
import { InvitationErrorIcons } from '../errors';
const styledTagTextIsInvalidCss = "s15ogmlx";
const styledTagTextCss = "s1mbmdkk";
const StyledTagText = forwardRef((props, ref) => {
  const {
    isInvalid
  } = props;
  return <TagText ref={ref} {...props} className={classNames(styledTagTextCss, {
    [styledTagTextIsInvalidCss]: isInvalid
  }, props.className)} />;
});
const styledDeleteTagButtonIsInvalidCss = "s78m1t3";
const styledDeleteTagButtonCss = "skhvbv";
const StyledDeleteTagButton = forwardRef((props, ref) => {
  const {
    isInvalid
  } = props;
  return <DeleteTagButton ref={ref} {...props} className={classNames(styledDeleteTagButtonCss, {
    [styledDeleteTagButtonIsInvalidCss]: isInvalid
  }, props.className)} />;
});
const iconContainerCss = "i1w6s0c8";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
export const NormalView = ({
  name,
  email,
  onDelete,
  toggleView
}) => {
  const [_fieldProps, {
    error = []
  }] = useFormField({
    name
  });
  const isInvalid = useMemo(() => !!error.length, [error]);
  const handleKeyDown = useCallback(handler => event => {
    if (isEnterKey(event) || isSpaceKey(event)) {
      handler();
      event.preventDefault();
    }
  }, []);
  const handleMouseDown = useCallback(event => {
    toggleView();
    event.preventDefault();
    event.stopPropagation();
  }, [toggleView]);
  return <>
      <StyledTagText as="div" role="button" tabIndex={0} isInvalid={isInvalid} onClick={handleMouseDown} onKeyDown={handleKeyDown(toggleView)}>
        <IconContainer>
          <InvitationErrorIcons types={error.map(e => e.key)} />
        </IconContainer>
        <FullStoryMask>
          {email}
        </FullStoryMask>
      </StyledTagText>
      <StyledDeleteTagButton aria-label={I18n.t('action.remove')} as="div" role="button" tabIndex={0} isInvalid={isInvalid} onClick={onDelete} onKeyDown={handleKeyDown(onDelete)}>
        <Icon name="close" />
      </StyledDeleteTagButton>
    </>;
};

require("./normal_view.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./normal_view.js");